export default "__VITE_ASSET__FoJ7OBWj__"